import ButtonsMain from '../Button/ButtonMain';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
//import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";

export default function CustomDialog({ open, onClose, title, content, image, sources, action, paperMaxWidth = '700px' }) {
   
const theme = useTheme();
    // background.paper defaults to MUI's stock dark value (#121212), darker
    // than the app's own dark surfaces — greydark.C800 matches the rest of
    // the dark-mode UI instead of reading as near-black.
    const bg = theme.palette.mode === "dark"
      ? theme.palette.greydark.C800
      : theme.palette.background.dialog;

    return (
     
     <Dialog
             open={open}
             onClose={onClose}
             fullWidth
             maxWidth="sm"
             scroll="paper"
             // MUI's default Paper elevation (24) overlays a lightening gradient in
             // dark mode on top of whatever bgcolor is set — that's what was showing
             // as a lighter "frame" around the padded edges of the dialog. elevation
             // 0 removes the overlay so the flat bgcolor actually reads flat.
             PaperProps={{ elevation: 0 }}
             aria-labelledby="custom-dialog-title"
             aria-describedby="custom-dialog-content"

             BackdropProps={{
               // 0.5 alpha wasn't dark enough to fully hide blurred page content
               // (card corners etc.) peeking through behind the dialog in dark mode.
               sx: { backdropFilter: 'blur(8px)', backgroundColor: theme.palette.mode === "dark" ? 'rgba(0,0,0,0.75)' : 'rgba(255,255,255,0.25)' },
             }}

             sx={{ '& .MuiDialog-paper': {
                   bgcolor: bg,
                   pt: { xs: 2, sm: 4 },
                   pb: { xs: 2, sm: 4 },
                   pl: { xs: 0.5, sm: 4 },
                   pr: { xs: 0.5, sm: 4 },
                   borderRadius: '24px',
                   maxHeight: { xs: '85dvh', sm: '90vh' },
                   display: 'flex',
                   flexDirection: 'column',
                   overflow: 'hidden',
                   maxWidth: { sm: paperMaxWidth },
                 },
               }}
                 >

        {/* Close button — its own row above the title, not overlapping it */}
        <Box sx={{
          flexShrink: 0,
          display: 'flex',
          justifyContent: 'flex-end',
          bgcolor: bg,
          px: { xs: 1, sm: 2 },
          pt: { xs: 1, sm: 1 },
        }}>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ color: theme.palette.text.secondary }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <DialogTitle id="custom-dialog-title"
          sx={{
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: bg,
            pt: 0,
            px: { xs: 2, sm: 3 },
          }}
        >

                <Typography
                  variant="h5"
                  component="span" // prevents invalid <h4> inside <h2>
                  sx={{
                    flex: 1,
                    textAlign: 'left',
                    color: theme.palette.text.primary,
                    fontWeight: 600,
                  }}
                >
                  {title}
                </Typography>

        </DialogTitle>
      
       <DialogContent
            id="custom-dialog-content"
            sx={{
              bgcolor: bg,
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              overflowY: 'auto',
              flex: 1,
              minHeight: 0,
              px: { xs: 2, sm: 3 },
            }}
          >
            {content && <div>{content}</div>}

            {image && <div>{image}</div>}

            {sources && (
              <Typography
                variant="h6"
                sx={{
                  px: 4,
                  fontWeight: 400,
                }}
              >
                {sources}
              </Typography>
            )}
        </DialogContent>
   
      </Dialog>
    );
  }